function dataStorageService() {

    const setLocalStorageData = (key, value) => {
        try {
            localStorage.setItem(key, value);
        } catch (error) {
            console.error("Error setting value in localStorage:", error);
        }
    };

    const getLocalStorageData = (key) => {
        try {
            return localStorage.getItem(key);
        } catch (error) {
            console.error("Error getting value from localStorage:", error);
            return null;
        }
    };

    const removeLocalStorageData = (key) => {
        try {
            localStorage.removeItem(key);
        } catch (error) {
            console.error("Error removing value from localStorage:", error);
        }
    };

    const clearLocalStorage = () => {
        try {
            localStorage.clear();
        } catch (error) {
            console.error("Error clearing localStorage:", error);
        }
    };

    const setSeassionStorageData = (key, value) => {
        try {
            sessionStorage.setItem(key, value);
        } catch (error) {
            console.error("Error setting value in sessionStorage:", error);
        }
    };

    const getSeassionStorageData = (key) => {
        try {
            return sessionStorage.getItem(key);
        } catch (error) {
            console.error("Error getting value from sessionStorage:", error);
            return null;
        }
    };

    const removeSeassionStorageData = (key) => {
        try {
            sessionStorage.removeItem(key);
        } catch (error) {
            console.error("Error removing value from sessionStorage:", error);
        }
    };

    const clearSeassionStorage = () => {
        try {
            sessionStorage.clear();
        } catch (error) {
            console.error("Error clearing sessionStorage:", error);
        }
    };


    return {
        setLocalStorageData,
        getLocalStorageData,
        removeLocalStorageData,
        clearLocalStorage,
        setSeassionStorageData,
        getSeassionStorageData,
        removeSeassionStorageData,
        clearSeassionStorage
    }
}

export default dataStorageService 

